import { Testimonial } from 'components/Modals/Signup/TenantSignUp'
import { useAppContext } from 'context/AppContext'
import { getTranslation } from 'utils/language-helper'

export const CardItem = (props: Testimonial) => {
    const { translations } = useAppContext()
    const { imageUrl, reviewerName, testimony, reviewerTitle } = props
    return (
        <div className=" flex flex-col gap-4 px-6 py-6 card-body">
            <div className="flex justify-end  font_awesome_icon"></div>
            <div
                className="text-base font-bold leading-7 text-justify"
                dangerouslySetInnerHTML={{
                    __html: getTranslation(testimony || '', translations),
                }}
            ></div>
            {/* <p className="text-base font-bold leading-7 text-justify">
                Duis in integer quis faucibus nunc. Mattis orci dis maecenas
                sagittis pretium, blandit non vitae rutrum. Ullamcorper
                platea vel purus mi etiam nunc dolor diam pulvinar.
                Dignissim fringilla nec et integer volutpat. Orci, purus
                mauris diam fringilla quam. Sit risus, enim vehicula ut
                volutpat euismod. Cursus vulputate justo sit in in enim
                molestie sed. Pharetra convallis massa et, in.
            </p> */}
            <div className="flex gap-4">
                <img
                    src={imageUrl}
                    className="w-16 h-16 rounded-full"
                    alt={translations[testimony]}
                    loading="lazy"
                />
                <div className="flex flex-col">
                    <p
                        className="text-lg font-bold reviewer-name circular_std"
                        style={{ color: '#094072' }}
                    >
                        {reviewerName}
                    </p>
                    <p
                        style={{ color: '#25A5DF' }}
                        className="font-semibold reviewer-title circular_std"
                    >
                        {reviewerTitle}
                    </p>
                </div>
            </div>
        </div>
    )
}
